/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { VendorInviteLogDto } from '../models/vendor-invite-log-dto';
import { vendorWorkspaceInviteLogControlllerAcceptInvite } from '../fn/vendor-workspace-invite-logs/vendor-workspace-invite-log-controlller-accept-invite';
import { VendorWorkspaceInviteLogControlllerAcceptInvite$Params } from '../fn/vendor-workspace-invite-logs/vendor-workspace-invite-log-controlller-accept-invite';
import { vendorWorkspaceInviteLogControlllerCancelInvite } from '../fn/vendor-workspace-invite-logs/vendor-workspace-invite-log-controlller-cancel-invite';
import { VendorWorkspaceInviteLogControlllerCancelInvite$Params } from '../fn/vendor-workspace-invite-logs/vendor-workspace-invite-log-controlller-cancel-invite';
import { vendorWorkspaceInviteLogControlllerInviteUser } from '../fn/vendor-workspace-invite-logs/vendor-workspace-invite-log-controlller-invite-user';
import { VendorWorkspaceInviteLogControlllerInviteUser$Params } from '../fn/vendor-workspace-invite-logs/vendor-workspace-invite-log-controlller-invite-user';
import { vendorWorkspaceInviteLogControlllerRejectInvite } from '../fn/vendor-workspace-invite-logs/vendor-workspace-invite-log-controlller-reject-invite';
import { VendorWorkspaceInviteLogControlllerRejectInvite$Params } from '../fn/vendor-workspace-invite-logs/vendor-workspace-invite-log-controlller-reject-invite';
import { vendorWorkspaceInviteLogControlllerSearchCursor } from '../fn/vendor-workspace-invite-logs/vendor-workspace-invite-log-controlller-search-cursor';
import { VendorWorkspaceInviteLogControlllerSearchCursor$Params } from '../fn/vendor-workspace-invite-logs/vendor-workspace-invite-log-controlller-search-cursor';
import { vendorWorkspaceInviteLogControlllerSearchOffset } from '../fn/vendor-workspace-invite-logs/vendor-workspace-invite-log-controlller-search-offset';
import { VendorWorkspaceInviteLogControlllerSearchOffset$Params } from '../fn/vendor-workspace-invite-logs/vendor-workspace-invite-log-controlller-search-offset';

@Injectable({ providedIn: 'root' })
export class VendorWorkspaceInviteLogsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `vendorWorkspaceInviteLogControlllerSearchOffset()` */
  static readonly VendorWorkspaceInviteLogControlllerSearchOffsetPath = '/api/vendorWorkspaceInviteLogs/invite/search/offset';

  /**
   * 입점사 초대 내역 오프셋 기반 검색.
   *
   * 입점사 초대 내역을 오프셋 기반으로 검색합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceInviteLogControlllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceInviteLogControlllerSearchOffset$Response(params: VendorWorkspaceInviteLogControlllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return vendorWorkspaceInviteLogControlllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 초대 내역 오프셋 기반 검색.
   *
   * 입점사 초대 내역을 오프셋 기반으로 검색합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceInviteLogControlllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceInviteLogControlllerSearchOffset(params: VendorWorkspaceInviteLogControlllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.vendorWorkspaceInviteLogControlllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceInviteLogControlllerSearchCursor()` */
  static readonly VendorWorkspaceInviteLogControlllerSearchCursorPath = '/api/vendorWorkspaceInviteLogs/invite/search/cursor';

  /**
   * 입점사 초대 내역 커서 기반 검색.
   *
   * 입점사 초대 내역을 커서 기반으로 검색합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceInviteLogControlllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceInviteLogControlllerSearchCursor$Response(params: VendorWorkspaceInviteLogControlllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return vendorWorkspaceInviteLogControlllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 초대 내역 커서 기반 검색.
   *
   * 입점사 초대 내역을 커서 기반으로 검색합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceInviteLogControlllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceInviteLogControlllerSearchCursor(params: VendorWorkspaceInviteLogControlllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.vendorWorkspaceInviteLogControlllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceInviteLogControlllerInviteUser()` */
  static readonly VendorWorkspaceInviteLogControlllerInviteUserPath = '/api/vendorWorkspaceInviteLogs/{id}/invite';

  /**
   * 입점사 구성원 초대.
   *
   * 입점사 멤버를 초대합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceInviteLogControlllerInviteUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorWorkspaceInviteLogControlllerInviteUser$Response(params: VendorWorkspaceInviteLogControlllerInviteUser$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorInviteLogDto>> {
    return vendorWorkspaceInviteLogControlllerInviteUser(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 구성원 초대.
   *
   * 입점사 멤버를 초대합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceInviteLogControlllerInviteUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorWorkspaceInviteLogControlllerInviteUser(params: VendorWorkspaceInviteLogControlllerInviteUser$Params, context?: HttpContext): Observable<VendorInviteLogDto> {
    return this.vendorWorkspaceInviteLogControlllerInviteUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorInviteLogDto>): VendorInviteLogDto => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceInviteLogControlllerAcceptInvite()` */
  static readonly VendorWorkspaceInviteLogControlllerAcceptInvitePath = '/api/vendorWorkspaceInviteLogs/invite/{id}/accept';

  /**
   * 입점사 초대 수락.
   *
   * 입점사 초대를 수락합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceInviteLogControlllerAcceptInvite()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceInviteLogControlllerAcceptInvite$Response(params: VendorWorkspaceInviteLogControlllerAcceptInvite$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return vendorWorkspaceInviteLogControlllerAcceptInvite(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 초대 수락.
   *
   * 입점사 초대를 수락합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceInviteLogControlllerAcceptInvite$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceInviteLogControlllerAcceptInvite(params: VendorWorkspaceInviteLogControlllerAcceptInvite$Params, context?: HttpContext): Observable<void> {
    return this.vendorWorkspaceInviteLogControlllerAcceptInvite$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceInviteLogControlllerRejectInvite()` */
  static readonly VendorWorkspaceInviteLogControlllerRejectInvitePath = '/api/vendorWorkspaceInviteLogs/invite/{id}/reject';

  /**
   * 입점사 초대 거절.
   *
   * 입점사 초대를 거절합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceInviteLogControlllerRejectInvite()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceInviteLogControlllerRejectInvite$Response(params: VendorWorkspaceInviteLogControlllerRejectInvite$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return vendorWorkspaceInviteLogControlllerRejectInvite(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 초대 거절.
   *
   * 입점사 초대를 거절합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceInviteLogControlllerRejectInvite$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceInviteLogControlllerRejectInvite(params: VendorWorkspaceInviteLogControlllerRejectInvite$Params, context?: HttpContext): Observable<void> {
    return this.vendorWorkspaceInviteLogControlllerRejectInvite$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceInviteLogControlllerCancelInvite()` */
  static readonly VendorWorkspaceInviteLogControlllerCancelInvitePath = '/api/vendorWorkspaceInviteLogs/{vendorWorkspaceId}/invite/{inviteId}/cancel';

  /**
   * 입점사 초대 취소.
   *
   * 입점사 초대를 취소합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceInviteLogControlllerCancelInvite()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceInviteLogControlllerCancelInvite$Response(params: VendorWorkspaceInviteLogControlllerCancelInvite$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return vendorWorkspaceInviteLogControlllerCancelInvite(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 초대 취소.
   *
   * 입점사 초대를 취소합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceInviteLogControlllerCancelInvite$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceInviteLogControlllerCancelInvite(params: VendorWorkspaceInviteLogControlllerCancelInvite$Params, context?: HttpContext): Observable<void> {
    return this.vendorWorkspaceInviteLogControlllerCancelInvite$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
